import zhCN from './zh_CN';
export default zhCN;
export * from './types';
export { default as ar } from './ar';
export { default as deDE } from './de_DE';
export { default as enGB } from './en_GB';
export { default as esES } from './es_ES';
export { default as frFR } from './fr_FR';
export { default as idID } from './id_ID';
export { default as itIT } from './it_IT';
export { default as jaJP } from './ja_JP';
export { default as koKR } from './ko_KR';
export { default as mnMN } from './mn_MN';
export { default as msMY } from './ms_MY';
export { default as ruRU } from './ru_RU';
export { default as thTH } from './th_TH';
export { default as trTR } from './tr_TR';
export { default as viVN } from './vi_VN';
export { default as zhCN } from './zh_CN';